import React, { useState } from "react";
import ProfileInfoTab from "./TabContent/ProfileInfoTab";
import SecurityTab from "./TabContent/SecurityTab";
import PreferencesTab from "./TabContent/PreferencesTab";
import ScrollbarWrapper from "../../../ACS-Blocks/ScrollbarWrapper";

import {
  UserCircle2,
  Lock,
  SlidersHorizontal,
} from "lucide-react";

const tabs = [
  { id: "info", label: "Profile Info", icon: UserCircle2 },
  { id: "security", label: "Security", icon: Lock },
  { id: "preferences", label: "Preferences", icon: SlidersHorizontal },
];

const ProfilePage = ({ user, onClose, onViewOrganization }) => {
  const [activeTab, setActiveTab] = useState("info");

  const renderTab = () => {
    switch (activeTab) {
      case "info":
        return (
          <ProfileInfoTab
            user={user}
            onClosePanel={onClose}
            onViewOrganization={onViewOrganization}
          />
        );
      case "security":
        return <SecurityTab />;
      case "preferences":
        return <PreferencesTab />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col flex-1 min-h-0">

      {/* TAB LIST */}
      <div className="flex gap-fluid-4 px-fluid-3 py-fluid-2 border-b border-gray-300 dark:border-acs-dark-border overflow-x-auto">
        {tabs.map((t) => {
          const Icon = t.icon;
          const isActive = activeTab === t.id;

          return (
            <button
              key={t.id}
              onClick={() => setActiveTab(t.id)}
              className={`
                flex items-center gap-fluid-1 pb-fluid-1 relative
                text-fluid-sm font-medium transition
                ${
                  isActive
                    ? "text-[#223688] dark:text-[#31C4AB]"
                    : "text-gray-600 dark:text-acs-dark-subtext hover:text-gray-900 dark:hover:text-white"
                }
              `}
            >
              <Icon className="w-fluid-icon-sm h-fluid-icon-sm" />
              <span>{t.label}</span>

              {isActive && (
                <span
                  className="
                    absolute bottom-0 left-0 right-0
                    h-[3px] bg-[#223688] dark:bg-[#31C4AB]
                    rounded-full
                  "
                ></span>
              )}
            </button>
          );
        })}
      </div>

      {/* TAB CONTENT */}
      <ScrollbarWrapper className="flex-1 min-h-0 overflow-y-auto p-fluid-3">
        {renderTab()}
      </ScrollbarWrapper>
    </div>
  );
};

export default ProfilePage;
